import { render, staticRenderFns } from "./Substance.vue?vue&type=template&id=53092628&"
import script from "./Substance.vue?vue&type=script&lang=js&"
export * from "./Substance.vue?vue&type=script&lang=js&"
import style0 from "./Substance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports